import React, { createContext, useContext } from 'react';

export type SidebarExpandedContextValue = {
  getExpanded: (key: string) => boolean | undefined;
  setExpanded: (key: string, expanded: boolean) => void;
};

export const SidebarExpandedContext = createContext<SidebarExpandedContextValue | null>(null);

export function useSidebarExpanded(): SidebarExpandedContextValue | null {
  return useContext(SidebarExpandedContext);
}

export function sidebarGroupExpandKey(itemName: string, parentKey?: string): string {
  return parentKey ? `${parentKey} › ${itemName}` : itemName;
}
